const STICKY_THRESHOLD_PX = 20;

const getScrollTop = () => document.scrollingElement?.scrollTop ?? window.scrollY ?? 0;

const updateStickyClass = (header) => {
  const shouldBeSticky = getScrollTop() > STICKY_THRESHOLD_PX;
  header.classList.toggle('is-sticky', shouldBeSticky);
};

const init = () => {
  const header = document.querySelector('#header-component');
  if (!(header instanceof HTMLElement)) return;

  let rafId = null;

  const onScroll = () => {
    if (rafId !== null) return;
    rafId = requestAnimationFrame(() => {
      rafId = null;
      updateStickyClass(header);
    });
  };

  updateStickyClass(header);
  document.addEventListener('scroll', onScroll, { passive: true });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
